module.exports = __webpack_public_path__ + "static/media/image-settings.1dc46cdd.svg";